<template>
  <v-container style="margin-top: -100px;">
    <!-- <v-row align="center" class="row--35"> -->
    <v-row class="row--35">
      <v-col lg="9" md="9" cols="12">
        <div class="about-inner inner">
          <v-row class="mt--50">
            <!-- <v-col class="mt--20 mb--20 .d-none .d-sm-block" sm="12" lg="4" md="12" cols="12">
              <div>
                <slot name="thum-img"></slot>
              </div>
            </v-col> -->
            <v-col lg="9" md="12" sm="12" cols="12">
              <v-row>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <h3 class="heading-title colorBlue">ΝΟΣΗΛΕΙΑ</h3>
                  <!-- <h3 class="heading-title">Έκπτωση 10%</h3> -->
                  <p
                    style="font-size: 24px; margin-top: -10px;margin-bottom: 5px;"
                    class="regularStyle"
                  >
                    Έκπτωση 10%
                  </p>
                  <p style="color: #1d1d24;font-size: 16px;">
                    Η έκπτωση γίνεται επί του ιδιωτικού τιμοκαταλόγου. Της
                    έκπτωσης εξαιρούνται υλικά, ειδικά υλικά, φάρμακα, αμοιβές
                    ιατρών. Εξαιρούνται των εκπτώσεων άγονες, μοριακές
                    εξετάσεις.
                  </p>
                  <div class="d-sm-block d-md-none">
                    <hr class=" new3 mt--30 mt_sm-20" />
                  </div>
                </v-col>

                <v-col
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="mt_sm--20 mt_md--20"
                >
                  <h3 class="heading-title colorBlue">ΜΕΤΑΦΟΡΑ</h3>
                  <!-- <h3 class="heading-title">Δωρεάν μεταφορά</h3> -->
                  <p
                    style="font-size: 24px; margin-top: -10px;margin-bottom: 5px;"
                    class="regularStyle"
                  >
                    Δωρεάν μεταφορά
                  </p>
                  <ul>
                    <li style="color: #1d1d24;">
                      με ασθενοφόρο σε περίπτωση νοσηλείας εντός Αττικής
                    </li>
                    <li style="color: #1d1d24;">
                      δωρεάν διακομιδή εισαγωγής από τα διαγνωστικά κέντρα
                      Healthspot σε Κλινική HHG.
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr class="new3 mt--30 mt_sm-20" />

          <v-row class="mt--30">
            <v-img
              max-height="60"
              max-width="60"
              style="margin-left: 12px;"
              class="mb--10"
              src="../../assets/images/pronomia/pregnancy1.png"
            ></v-img>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3 class="heading-title colorBlue">ΕΓΚΥΜΟΣΥΝΗ & ΤΟΚΕΤΌΣ</h3>
              <!-- <h3 class="heading-title">Πακέτα τοκετού και προγεννητικού ελέγχου</h3> -->
              <p
                style="font-size: 24px; margin-top: -10px;margin-bottom: 5px;"
                class="regularStyle"
              >
                Πακέτα τοκετού και προγεννητικού ελέγχου
              </p>
              <p
                style="
    font-size: 16px;
    line-height: 1.5;"
              >
                Ενημερωθείτε για τα προνομιακά πακέτα τοκετού και προγεννητικού
                ελέγχου στη Μαιευτική Γυναικολογική Κλινική Μητέρα στα τηλέφωνα:
                210 68 69 000 & 210 68 69 274
              </p>
            </v-col>
          </v-row>
          <hr class="new3 mt--30 mt_sm-20" />

          <v-row class="mt--30 ">
            <v-img
              max-height="60"
              max-width="60"
              style="margin-left: 12px;"
              class="mb--10"
              src="../../assets/images/pronomia/exetaseis1.png"
            ></v-img>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="d-sm-flex">
                    <div class="p-6">
                      <h3 class="heading-title colorBlue mt_sm--0">
                        ΔΙΑΓΝΩΣΤΙΚΕΣ ΕΞΕΤΑΣΕΙΣ
                      </h3>
                    </div>
                    <div class="p-6">
                      <p
                        style="font-size: 13px; line-height: 1.5; color: #777978"
                        class="mb_sm--20 mb_md--20 ml--10 ml_sm--0"
                      >
                        (Υγεία, Μetropolitan Hospital, Μητέρα, <br />
                        Metropolitan General, Λητώ, Creta Interclinic)
                      </p>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <ul>
                <li class="mt--5" style="line-height: 1.5">
                  Ευνοϊκή τιμολογιακή πολιτική στις διαγνωστικές και
                  εργαστηριακές εξετάσεις στα εξωτερικά ιατρεία και στα τμήματα
                  επειγόντων περιστατικών των θεραπευτηρίων: παρέχεται η τιμή
                  κρατικού τιμοκαταλόγου +30 % (ΦΕΚ+30%)
                </li>
                <li class="mt--5" style="line-height: 1.5">
                  Σε Μαγνητικές Τομογραφίες (MRI), Αξονικές Τομογραφίες (CT) και
                  Triplex Καρδιάς και Σώματος παρέχεται τιμή κρατικού
                  τιμοκαταλόγου (ΦΕΚ)
                </li>
                <li class="mt--5" style="line-height: 1.5">
                  Στις εξετάσεις Μοριακής Βιολογίας καθώς και σε ειδικές
                  Αξονικές και Μαγνητικές Τομογραφίες (π.χ. Αξονική
                  Στεφανιογραφία, Μαγνητική Τομογραφία Καρδιάς, Μαγνητική
                  Μαστών, Φασματοσκοπία κτλ.) έκπτωση 20% επί του ιδιωτικού
                  τιμοκαταλόγου
                </li>
              </ul>
              <v-col class="d-block d-sm-none" cols="12">
                <img
                  max-height="150"
                  style="margin-left: -18px;"
                  src="../../assets/images/pronomia/health.png"
                />
              </v-col>
              <h3
                class="heading-title heading-title-new"
                style="font-size: 20px"
              >
                Διαγνωστικά Κέντρα ΗealthSpot
              </h3>
              <ul>
                <li>
                  Δωρεάν συνταγογράφηση διαγνωστικών εξετάσεων όταν
                  πραγματοποιούνται στα διαγνωστικά κέντρα HealthSpot
                </li>
                <li>
                  Τιμές ΦΕΚ σε αιματολογικές εξετάσεις (χωρίς χρήση
                  παραπεμπτικού ΕΟΠΥΥ)
                </li>
                <li class="mt--5" style="line-height: 1.5">
                  Μοριακός έλεγχος για την ανίχνευση του Sars-Cov-2 (Covid-19) -
                  50€
                </li>
                <li class="mt--5" style="line-height: 1.5">
                  10% έκπτωση επί του ιδιωτικού τιμοκαταλόγου στις ακτινογραφίες
                  (χωρίς χρήση παραπεμπτικού ΕΟΠΥΥ)
                </li>
                <li class="mt--5" style="line-height: 1.5">
                  10% έκπτωση επί του ιδιωτικού τιμοκαταλόγου στους υπερήχους
                  (χωρίς χρήση παραπεμπτικού ΕΟΠΥΥ)
                </li>
              </ul>
            </v-col>
          </v-row>
          <hr class="new3 mt--30 mt_sm-20" />

          <v-row class="mt--20   .d-block .d-sm-none">
            <v-img
              max-height="60"
              max-width="60"
              style="margin-left: 12px;"
              class="mb--10"
              src="../../assets/images/pronomia/docare1.png"
            ></v-img>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="d-flex">
                <div class="p-6">
                  <h3 class="heading-title colorBlue">
                    DOCARE ΠΑΡΟΧΕΣ
                  </h3>
                </div>
                <div class="p-6">
                  <p
                    style="font-size: 13px; line-height: 1.5; color: #777978"
                    class="mt--5 ml--10"
                  >
                    (Μητέρα)
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row>
                <v-col lg="12" md="12" sm="12" cols="12">
                  <h3
                    class="heading-title heading-title-new"
                    style="font-size: 20px"
                  >
                    Υπηρεσίες αδυνατίσματος
                  </h3>
                  <ul>
                    <li>
                      Πρόγραμμα αδυνατίσματος & σμίλευσης σώματος<span
                        class="colorBlue"
                      >
                        με 55 € η συνεδρία</span
                      >
                    </li>
                  </ul>
                  <h3
                    class="heading-title heading-title-new"
                    style="font-size: 20px"
                  >
                    Υπηρεσίες ομορφιάς
                  </h3>
                  <ul>
                    <li>
                      Πρόγραμμα Laser αποτρίχωση Full Body
                      <span class="colorBlue">με 175€ η συνεδρία</span>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr class="new3 mt--30 mt_sm-20" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped>
.colorBlue {
  color: rgb(22 71 141);
  font-family: PFBagueSansPro-Bold;
  font-weight: bold;
}
th {
  font-size: 14px !important;
}
.freeTicket {
  background-color: rgb(132, 135, 136);
  position: absolute;
  margin-bottom: 20px;
  left: -23%;
  right: 71%;
  text-align: right;
  color: white;
  font-size: 25px;
  font-weight: bold;
  border-top-right-radius: 25px 22px;
  border-bottom-right-radius: 25px 22px;
  padding-right: 20px;
}

.freeTicketRight {
  background-color: rgb(132, 135, 136);
  position: absolute;
  margin-bottom: 20px;
  left: 0%;
  right: 58%;
  text-align: right;
  color: white;
  font-size: 25px;
  font-weight: bold;
  border-top-right-radius: 25px 22px;
  border-bottom-right-radius: 25px 22px;
  padding-right: 20px;
}

h3 {
  font-family: "PFBagueSansPro-Bold";
  line-height: 1.5;
}

p {
  line-height: 1.5;
}

.v-application p[data-v-5c94bd40],
body p[data-v-5c94bd40] {
  line-height: 1.5;
}

.v-application ul,
.v-application ol,
body ul,
body ol {
  line-height: 1.5;
}
@media only screen and (max-width: 600px) {
  .heading-title-new {
    font-size: 16px !important;
  }
}
</style>
